export default (theme) => ({
  browser__svg: {
    height: 30,
    width: 30,
    '&:hover': {
      filter: 'hue-rotate(10deg)',
    },
  },
});
